<template>
  <v-card class="pa-4" flat>
    <v-progress-linear v-show="loading" class="mb-4" indeterminate />

    <v-form ref="form" v-model="valid" lazy-validation>
      <div class="pa-5 border rounded-xl" style="background: #f9f9f9">
        
        <v-row>
          <v-col cols="12" md="8" sm="12">
            <div class="d-flex flex-column flex-sm-row align-start align-sm-center justify-start">
                <span class="ml-sm-4 mb-3 mb-sm-0 font-weight-bold grey--text text--darken-1 text-body-2">
                نوع تنظیمات را انتخاب کنید:
              </span>
              
                  <v-btn-toggle
                      v-model="formData.type"
                      mandatory
                      rounded
                      class="d-flex w-100 flex-sm-row"
                      color="primary "
                      background-color="grey lighten-4"
                      @change="changeType"
                    >                
                  <v-btn value="anbar" active-class="primary white--text elevation-3" class="flex-grow-1">
                  <v-icon right size="22" :class="formData.type === 'anbar' ? 'white--text' : 'grey--text'">
                    mdi-package-variant-closed
                  </v-icon>
                  <span class="mr-2 font-weight-bold" :class="formData.type === 'anbar' ? 'white--text' : 'grey--text text--darken-2'">
                    انبارش
                  </span>
                </v-btn>

                <v-btn value="daily" active-class="primary white--text elevation-3" class="flex-grow-1">
                  <v-icon right size="22" :class="formData.type === 'daily' ? 'white--text' : 'grey--text'">
                    mdi-calendar-check-outline
                  </v-icon>
                  <span class="mr-2 font-weight-bold" :class="formData.type === 'daily' ? 'white--text' : 'grey--text text--darken-2'">
                    روزانه
                  </span>
                </v-btn>
              </v-btn-toggle>
            </div>
          </v-col>
        </v-row>

        <v-divider class="my-4"></v-divider>

        <v-row>
          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="formData.delivery_type"
              :items="deliveryTypes"
              item-text="text"
              item-value="value"
              label="نوع تحویل"
              prepend-inner-icon="mdi-truck-delivery-outline"
              outlined
              dense
              :rules="[rules.required]"
              @change="onChangeDeliveryType" 
            >
              <template v-slot:item="{ item }">
                <v-icon class="ml-3" color="grey darken-1">{{ item.icon }}</v-icon>
                <span>{{ item.text }}</span>
              </template>
              <template v-slot:selection="{ item }">
                <v-icon class="ml-2" size="20" color="primary">{{ item.icon }}</v-icon>
                <span class="text-body-2">{{ item.text }}</span>
              </template>
            </v-autocomplete>
          </v-col>
          
          <v-col cols="12" md="6">
            <timepicker
              v-model="formData.package_creation_time"
              label="ساعت ساخت محموله"
              prepend-icon="mdi-clock-outline"
              :rules="[rules.required]"
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="formData.hub_warehouse_id"
              :items="availableMainWarehouses"
              item-text="title"
              item-value="warehouse_id"
              label="انتخاب انبار اصلی"
              prepend-inner-icon="mdi-warehouse"
              outlined
              dense
              :rules="[rules.required]"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="formData.backup_warehouse_id"
              :items="availableBackupWarehouses"
              item-text="title"
              item-value="warehouse_id"
              label="انتخاب انبار پشتیبان"
              prepend-inner-icon="mdi-shield-home-outline"
              outlined
              dense
              clearable
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" md="6" v-if="formData.type !== 'daily'">
            <v-autocomplete
              v-model="formData.shipping_type"
              :items="shippingTypes"
              item-text="text"
              item-value="value"
              label="نوع ارسال "
              prepend-inner-icon="mdi-account-tie-voice"
              outlined
              dense
              clearable
            >
              <template v-slot:item="{ item }">
                <v-icon class="ml-3" color="grey darken-1">{{ item.icon }}</v-icon>
                <span>{{ item.text }}</span>
              </template>
              <template v-slot:selection="{ item }">
                <v-icon class="ml-2" size="20" color="primary">{{ item.icon }}</v-icon>
                <span class="text-body-2">{{ item.text }}</span>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="12" md="3">
            <v-text-field
              v-model.number="formData.retry_attempts"
              label="تعداد دفعات تلاش"
              type="number"
              prepend-inner-icon="mdi-refresh"
              outlined
              dense
              :rules="[rules.required, rules.minZero]"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="3">
            <v-text-field
              v-model.number="formData.retry_interval_minutes"
              label="فاصله بین تلاش‌ها (دقیقه)"
              type="number"
              prepend-inner-icon="mdi-timer-sand"
              outlined
              dense
              :rules="[rules.required, rules.minZero]"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="3" v-if="formData.type === 'anbar'">
            <v-text-field
              v-model.number="formData.warehousing_days"
              label="بازه بررسی فروش"
              type="number"
              prepend-inner-icon="mdi-calendar-clock"
              outlined
              dense
              :rules="[rules.required, rules.minZero]"
            ></v-text-field>
          </v-col>

          <v-col cols="12" md="3" v-if="formData.type === 'anbar'">
            <v-text-field
              v-model.number="formData.warehousing_percentage"
              label="درصد انبارداری"
              type="number"
              prepend-inner-icon="mdi-percent"
              outlined
              dense
              :rules="[rules.required, rules.percent]"
            ></v-text-field>
          </v-col>

          <!-- بخش انتخاب روزهای فعالیت -->
          <v-col cols="12" v-if="formData.type === 'anbar'">
            <div class="mb-2">
              <v-icon color="grey darken-1" class="mr-1 ml-2">mdi-calendar-multiselect</v-icon>
              <span class="font-weight-bold grey--text text--darken-1 text-body-2">
                روزهای فعالیت را انتخاب کنید:
              </span>
            </div>
            
            <v-chip-group
              v-model="formData.active_days"
              column 
              multiple
              active-class="primary white--text"
              class="mb-4"
              @change="handleDaysChange"
            >
              <v-chip
                v-for="day in weekDays"
                :key="day.value"
                :value="day.value"
                filter
                outlined
                color="primary"
              >
                {{ day.text }}
              </v-chip>
            </v-chip-group>
          </v-col>
          <!-- پایان بخش انتخاب روزها -->

        </v-row>

        <v-row>
          <v-col cols="12" md="4">
            <v-switch 
              v-model="formData.status" 
              label="فعال کردن تنظیمات" 
              inset 
              dense
              class="mt-0"
              color="success"
            ></v-switch>
          </v-col>
        </v-row>

        <div class="d-flex flex-column flex-sm-row justify-end mt-6">
          <v-btn
            class="btn-get-code rounded-lg px-8 mb-4 mb-sm-0"
            @click.stop="saveSettings"
            :loading="saveLoading"
            :disabled="loading"
          >
            <v-icon left>mdi-content-save</v-icon>
            ذخیره تنظیمات
          </v-btn>
          <v-btn v-if="formData.type === 'anbar'"
            class="btn-download rounded-lg px-8 mr-sm-4"
            @click.stop="runSave"
            :loading="saveLoading"
          >
            <v-icon class="mx-2">mdi-content-save</v-icon>ثبت محموله انبارش
          </v-btn>
        </div>
      </div>
    </v-form>
  </v-card>
</template>

<script>
import Timepicker from "@/view/components/Timepicker";

export default {
  name: "DigikalaSettings",
  components: { Timepicker },
  data() {
    return {
      valid: false,
      loading: false,
      saveLoading: false,
      warehouses: [],
      warehouseSupport: [],
      weekDays: [
        { text: 'همه روزها', value: 'all' },
        { text: 'شنبه', value: 0 },
        { text: 'یکشنبه', value: 1 },
        { text: 'دوشنبه', value: 2 },
        { text: 'سه‌شنبه', value: 3 },
        { text: 'چهارشنبه', value: 4 },
        { text: 'پنج‌شنبه', value: 5 },
        { text: 'جمعه', value: 6 }
      ],

      shippingTypes:[
        {text:'همه',value: null,icon:'mdi-truck-delivery'},
        {text:'سه ساعته',value:'nearby', icon:'mdi-flash'},
        {text:'فروشنده',value:'seller', icon:'mdi-account-box-multiple'},
        {text:'دیجی کالا',value:'digikala', icon:'mdi-storefront'},
      ],
      deliveryTypes: [
        { text: 'توسط فروشنده', value: 'seller', icon: 'mdi-storefront-outline' },
        { text: 'تحویل انبار سیار', value: 'mobile_hub', icon: 'mdi-van-utility' },
        { text: 'توسط پست', value: 'post', icon: 'mdi-mailbox-open-outline' }
      ],
      formData: {
        package_creation_time: null,
        retry_attempts: 0,
        retry_interval_minutes: 0,
        delivery_type: "seller",
        hub_warehouse_id: null,
        backup_warehouse_id: null,
        warehousing_days: null,
        warehousing_percentage: null,
        active_days: [], 
        status: false,
        type: "anbar", // daily, anbar
        shipping_type: null,
      },
      rules: {
        required: value => (value !== null && value !== '' && value !== undefined) || 'این فیلد الزامی است.',
        minZero: value => value >= 0 || 'مقدار نمی‌تواند منفی باشد.',
        percent: value => (value >= 0 && value <= 100) || 'مقدار باید بین ۰ تا ۱۰۰ باشد.'
      }
    };
  },
  computed: {
    availableMainWarehouses() {
      if (!this.formData.backup_warehouse_id) return this.warehouses;
      return this.warehouses.filter(
        w => w.warehouse_id !== this.formData.backup_warehouse_id
      );
    },
    availableBackupWarehouses() {
      if (!this.formData.hub_warehouse_id) return this.warehouseSupport;
      return this.warehouseSupport.filter(
        w => w.warehouse_id !== this.formData.hub_warehouse_id
      );
    }
  },
  watch: {
    'formData.type'(newType) {
      if (newType === 'daily') {
        this.formData.warehousing_days = null;
        this.formData.warehousing_percentage = null;
        this.formData.active_days = [];
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    handleDaysChange(val) {
      if (val.includes('all')) {
        this.formData.active_days = this.weekDays
          .filter(d => d.value !== 'all')
          .map(d => d.value);
      }
            // this.formData.active_days = ['0', '1', '2', '3', '4', '5', '6'];

    },
    async onChangeDeliveryType() {
      this.formData.hub_warehouse_id = null;
      this.formData.backup_warehouse_id = null;
      await this.fetchWarehouses();
    },
    async runSave() {
      try {
        const res = await this.$api.post(`/v1/digikala/consignment-packages/run`, {
          "force": true
        });
        const message = res?.data?.message || res?.message;
        this.$toast.success(message);
      } catch (error) {
        this.$toast.error(error.response?.data?.message || "خطا در ارسال درخواست");
      }
    },
    async init() {
      this.loading = true;
      try {
        await this.fetchSettings();
        await this.fetchWarehouses();
      } catch (error) {
        this.$toast.error("خطا در دریافت اطلاعات اولیه");
      } finally {
        this.loading = false;
      }
    },
    async fetchWarehouses() {
      const res = await this.$api.get(`/v1/digikala/settings/warehouses?delivery_type=${this.formData.delivery_type}`);
      this.warehouses = res.data.data || res.data;
            const resSupport = await this.$api.get(`/v1/digikala/settings/warehouses`);
      this.warehouseSupport = resSupport.data.data || resSupport.data;

    },
    async fetchSettings() {
      const res = await this.$api.get(`/v1/digikala/settings?type=${this.formData.type}`);
      if (res.data && (res.data.data || Object.keys(res.data).length > 0)) {
        const settings = res.data.data || res.data;
        Object.keys(this.formData).forEach(key => {
          if (key !== 'type' && settings[key] !== undefined) {
            this.formData[key] = settings[key];
          }
        });
        
        if (Array.isArray(this.formData.active_days)) {
             this.formData.active_days = this.formData.active_days.map(d => Number(d));
        } else {
             this.formData.active_days = [];
        }      }
    },
    async changeType() {
      this.loading = true;
      try {
        await this.fetchSettings();
        await this.fetchWarehouses(); 
      } catch (error) {
        this.$toast.error("خطا در دریافت اطلاعات");
      } finally {
        this.loading = false;
      }
    },
    async saveSettings() {
      if (!this.$refs.form.validate()) {
        this.$toast.error("لطفاً خطاهای فرم را برطرف کنید.");
        return;
      }
      this.saveLoading = true;
      try {
        let formattedTime = this.formData.package_creation_time;
        if (formattedTime && formattedTime.split(':').length > 2) {
          formattedTime = formattedTime.split(':').slice(0, 2).join(':');
        }
        
        const payload = {
          ...this.formData,
          package_creation_time: formattedTime,
          active_days: this.formData.active_days
            .filter(day => day !== 'all')
            .map(day => Number(day)) 
        };
        await this.$api.post('/v1/digikala/settings/store', payload);
        this.$toast.success("تنظیمات با موفقیت ذخیره شد");
      } catch (error) {
        this.$toast.error("خطا در ذخیره تنظیمات");
      } finally {
        this.saveLoading = false;
      }
    }
  }
};
</script>

<style scoped>
.dTrans{
  justify-content: end;
  display: flex;
  align-items: end;
}
</style>
